import Schedule from './Schedule';
import ScheduleTick from './ScheduleTick';

const TERM_NAME = [
	'am',
	'pm',
];
export default class Term {
	get caption() {
		return TERM_NAME[this.code.substr(8, 1)];
	}

	get schedule() {
		return new Schedule({
			begin: new ScheduleTick({code: this.code}),
			end: new ScheduleTick({code: this.code}),
		});
	}

	constructor(params) {
		this.code = params.code;
		this.weekDayNum = params.weekDayNum;
		this.holiday = params.holiday;
	}
	
	isHoliday() {
		return (this.holiday != null);
	}
	getHolidayName(){
		return this.holiday.name;
	}
}